import React, { useEffect } from 'react';
import { AlertCircle, CheckCircle2, X } from 'lucide-react';

const ToastMessage = ({ toast, onClose }) => {
  useEffect(() => {
    if (!toast) return undefined;
    const timeout = window.setTimeout(onClose, 4000);
    return () => window.clearTimeout(timeout);
  }, [toast, onClose]);

  if (!toast) return null;

  const isError = toast.type === 'error';
  const Icon = isError ? AlertCircle : CheckCircle2;

  return (
    <div className="fixed right-6 top-6 z-[100] w-full max-w-sm">
      <div
        className={`flex items-start gap-3 rounded-xl border bg-white p-4 shadow-xl ${
          isError ? 'border-red-200' : 'border-green-200'
        }`}
      >
        <Icon
          className={`mt-0.5 h-5 w-5 shrink-0 ${
            isError ? 'text-red-600' : 'text-green-600'
          }`}
        />
        <p className="flex-1 text-sm font-medium text-gray-800">
          {toast.message}
        </p>
        <button
          type="button"
          onClick={onClose}
          className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-700"
          aria-label="Close notification"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default ToastMessage;
